<script setup>

defineProps({
  text: {
    type: String,
    required: true
  }
})
</script>
<template>
  <div class="tooltip-container">
    <slot />
        <div
      class="tooltip" v-html="text"
    >
    </div>
  </div>
</template>

<style scoped>
.tooltip-container {
  position: absolute;
  display: inline-block;
}

.tooltip-container:hover .tooltip{
  opacity: 1;
  pointer-events: none;

}
.tooltip {
  pointer-events: none;
  color: #033a6a;
  padding: 5px 0;
  border-radius: 2px;
  padding: 5px;
  border:1px;
  opacity: 0;
  transition: opacity 1s;
  z-index: 100;
  width: 150px;
  background: whitesmoke;
  font-size: 1.3rem;
  font-family: "Scania Sans Semi Condensed";
}

.text::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #000000 transparent transparent transparent;

}
</style>
